(function() {
    'use strict';
    
a3_cabin_reports.controller('UPGDCtrl', UPGDCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name UPGDCtrl
    * @description 
    *  Manages the UPGD Modal View
    * @ngInject
    */
function UPGDCtrl(upgradedPassenger, report, paxInfo, PaxInfoFactory, $scope, $uibModalInstance) {
        // get eligible passengers
        
        var paxInfo = paxInfo;
        var eligiblePassengers = getEligiblePassengers();
      
        $scope.eligiblePassengers = eligiblePassengers;
        $scope.clearUPGDRemarks = clearUPGDRemarks;

		var result = {};

		if (upgradedPassenger == null) {
            $scope.editMode = false;
			result.Object = null;
			result.isInsertMode = true;
		} else {
            $scope.editMode = true;
            result.Object = Object.assign({}, upgradedPassenger);
            result.Object.check = true;
			result.isInsertMode = false;
		}

        $scope.upgradedPassenger = result.Object;
        
        $scope.showUpgradeWarning = false;
        $scope.showUpgradeError = false;
        $scope.submitUpgrade = submitUpgrade;
        $scope.saveUpgrade = saveUpgrade;
        $scope.cancel = cancel;

		

        /**
         * Clear Field
         * @memberof UPGDCtrl
         */
        function clearField(target, fieldName) {
			if (target[fieldName] == null || target[fieldName] == '') return false;
			bootbox.dialog({
				message: "Please confirm that you wish to clear this field",
				title: "<strong>Attention<strong>",
				buttons: {
					cancel: {
						label: "Cancel",
						className: "btn-default",
						callback: function() {}
					},
					ok: {
						label: "Ok",
						className: "btn-warning",
						callback: function() {
							target[fieldName] = null;
							$scope.$apply();
							return true;
						}
					}
				}
			});
        }
        
        /**
         * fix any input into 000A format
         * @memberof UPGDCtrl
         */
        function formatSeatInput(){
			var missingZeroes = 4 - $scope.upgradedPassenger.UpgradedSeatNo.length;
			for (var i=0; i<missingZeroes; i++)
                $scope.upgradedPassenger.UpgradedSeatNo = '0' + $scope.upgradedPassenger.UpgradedSeatNo;
		}

        /**
         * Clear upgrade remarks
         * @memberof UPGDCtrl
         * @param {object} upgradedPassenger
         */
        function clearUPGDRemarks(upgradedPassenger) {
			clearField(upgradedPassenger, "Remarks");
		}
        
        /**
         * Gets called when user hits submit. checks input then saves
         * @memberof UPGDCtrl
         */
        function submitUpgrade() {
            $scope.showUpgradeError = false;
            if (!isSeatAvailable()){
				return;
            }
			saveUpgrade();
        }
        
        /**
         * Save the new upgrade to the report
         * @memberof UPGDCtrl
         */
        function saveUpgrade(){
			result.Object = $scope.upgradedPassenger;
                
            for (var i=0;i<eligiblePassengers.length;i++){
                if (eligiblePassengers[i].SeatNo == result.Object.OriginalSeatNo){
                    result.Object.UCI = eligiblePassengers[i].UCI;
                    result.Object.PNR = eligiblePassengers[i].PNR;
                }
            }
			$uibModalInstance.close(result);
		}

        /**
         * Check if seat exists and is empty. fires warnings and errors
         * @memberof UPGDCtrl
         * @return {boolean} isSeatAvailable
         */
        function isSeatAvailable(){
            $scope.upgradedPassenger.UpgradedSeatNo = $scope.upgradedPassenger.UpgradedSeatNo.toUpperCase();
            
            formatSeatInput();

            if (paxInfo){
				for(var i=0;i<paxInfo.Seatmap.length;i++){
					for(var j=0;j<paxInfo.Seatmap[i].Columns.length;j++){
						if (paxInfo.Seatmap[i].Columns[j].SeatNo == $scope.upgradedPassenger.UpgradedSeatNo){
							if (paxInfo.Seatmap[i].Columns[j].IsEmptySeat){
								return true;
							}
							$scope.showUpgradeWarning = true;
							return false;
						}
					}
				}
			}

			//not found in seatmap
			$scope.showUpgradeError = true;
			$scope.upgradedPassenger.UpgradedSeatNo = '';
			return false;
        }
        
        /**
         * Close modal
         * @memberof UPGDCtrl
         */
        function cancel() {
			$uibModalInstance.close(null);
        }
        
        /**
         * Get all passengers that are eligible for upgrade, are in Y cabin and have not been upgraded already
         * @memberof UPGDCtrl
         * @return {array} eligiblePassengers
         */
        function getEligiblePassengers(){
            var eligiblePassengersList = [];
            if (paxInfo){
                for(var i=0;i<paxInfo.Seatmap.length;i++){
                    for(var j=0;j<paxInfo.Seatmap[i].Columns.length;j++){
                        if (paxInfo.Seatmap[i].Columns[j].IsEligibleForUpgrade && paxInfo.Seatmap[i].Columns[j].Cabin == 'Y'){
                            var alreadyUpgraded = false;
                            for (var k=0;k<report.UpgradedPassengers.length;k++){
                                if (report.UpgradedPassengers[k].UCI == paxInfo.Seatmap[i].Columns[j].UCI &&
                                    report.UpgradedPassengers[k].PNR == paxInfo.Seatmap[i].Columns[j].PNR &&
                                    report.UpgradedPassengers[k].OriginalSeatNo == paxInfo.Seatmap[i].Columns[j].SeatNo){
                                        alreadyUpgraded = true;
                                }
                            }
                            if (!alreadyUpgraded){
                                eligiblePassengersList.push(paxInfo.Seatmap[i].Columns[j]);
                            }
                        }
                    }
                }
            }
            return eligiblePassengersList;
        }
	}

})();